
import { SMCases, SMUser, SMValidationModal } from "@/store";
import { API_ROUTES } from "@/utils/API";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { IEmployeeDashboard } from "@/models/dashboards";

import { TCompliantBlockRow } from "@/models/compliant_block";

import { COMPLIANT, UNDERTERMINED } from "@/constants/compliance";

const HOME_COMPLIANT_TITLE_CLASS = "widget-title";
const COMPLIANCE_BLOCK_CLASS = "cursor-pointer";
const TASKS_PATH = "/tasks/";

@Component({
  components: {
    CompliantBlock: () =>
      import("@/modules/Compliance/ComplianceWidgets/components/CompliantBlock.vue"),
    ComplianceBlock: () =>
      import("@/modules/Compliance/ComplianceWidgets/components/ComplianceBlock.vue"),
    CompliantBlockRow: () =>
      import("@/modules/Compliance/ComplianceWidgets/components/CompliantBlockRow.vue"),
    DateBlock: () => import("@/modules/Compliance/Blocks/DateBlock/DateBlock.vue"),
    TasksBlock: () => import("@/modules/Compliance/Blocks/TasksBlock/TasksBlock.vue"),
    Banner: () => import("@/components/Banner.vue"),
  },
})
export default class ComplianceWidgetEmployee extends Vue {
  @Prop({ type: Number, default: 0 }) readonly count!: number;
  @Prop({ type: Boolean, default: false }) readonly needsUpdate!: boolean;

  @Watch("isValidationModalOpen")
  isValidationModalOpenChanged() {
    if (!this.isValidationModalOpen) {
      this.getCompanyDashboard();
    }
  }

  @Watch("needsUpdate")
  async isNeedsUpdateChanged() {
    await this.getCompanyDashboard();
  }

  isCompliant: boolean | null = null;

  dashboard: IEmployeeDashboard = {
    compliance_status: UNDERTERMINED,
    employee_record_keeping_duties: null,
    employee_reporting_duties: null,
    visa_expiration_date: null,
    extension_in_progress_case_id: null,
  };

  complianceStatus = "";

  statuses = {
    undetermined: this.$root.$tc("labels.undetermined"),
    compliant: this.$root.$tc("labels.compliant"),
    not_compliant: this.$root.$tc("labels.notCompliant"),
  };

  get isValidationModalOpen() {
    return SMValidationModal.isOpen;
  }

  get isComplianceBlocked() {
    return SMUser.user?.is_compliance_blocked;
  }

  get title() {
    if (this.isComplianceBlocked) return this.$root.$tc("labels.undetermined");

    return this.complianceStatus;
  }

  created() {
    this.getCompanyDashboard();
  }

  async getCompanyDashboard() {
    const { data } = await this.axios.get<IEmployeeDashboard>(
      API_ROUTES.COMPLIANCE_EMPLOYEE_DASHBOARD
    );

    this.complianceStatus = this.statuses[data.compliance_status];

    this.dashboard = data;

    this.isCompliant = this.dashboard.compliance_status === COMPLIANT;
  }

  get companyDashboardRows() {
    const { employee_record_keeping_duties } = this.dashboard;

    const rows: TCompliantBlockRow[] = [
      { label: this.$tc("labels.recordKeepingDuties"), checked: employee_record_keeping_duties },
    ];

    return rows;
  }

  get employeesDashboardRows() {
    const { employee_reporting_duties } = this.dashboard;

    const rows: TCompliantBlockRow[] = [
      { label: this.$tc("labels.reportingDuties"), checked: employee_reporting_duties },
    ];

    return rows;
  }

  get classes() {
    if (this.title === this.$root.$tc("labels.compliant"))
      return `${HOME_COMPLIANT_TITLE_CLASS}_compliant`;

    if (this.title === this.$root.$tc("labels.notCompliant"))
      return `${HOME_COMPLIANT_TITLE_CLASS}_noncompliant`;

    return `${HOME_COMPLIANT_TITLE_CLASS}_compliant_unknown`;
  }

  get cursorClass() {
    return {
      [`${COMPLIANCE_BLOCK_CLASS}`]: !this.isComplianceBlocked,
    };
  }

  onTasksClick() {
    if (this.isComplianceBlocked) return;

    this.$emit("click");
  }

  async goInviteEmployee() {
    if (this.isComplianceBlocked) return;

    const { data } = await this.axios.get(API_ROUTES.COMPANY_EMPLOYEE_ONBOARD_EMPLOYEE);

    const { task_id } = data;

    await this.$router.push(`${SMUser.basePath}${TASKS_PATH}${task_id}`);
  }

  async goToService(caseId: number) {
    if (!caseId) return;

    await this.$router.push(`/cases/${caseId}/dashboard/${SMCases.tabId}`);
  }
}
